import { BUTTON_ACTIVE_BACKGROUND_COLOR_TRELLIS } from './constants/quickFilterButtonProperties';
import { ENUMERATION } from 'customer-data-objects/property/PropertyTypes';
import { DSFieldRecord } from '../../../public/core';
import { useContext, useState } from 'react';
import { useStrategy } from '../../../hooks/useStrategy';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SegmentationFiltersInstanceContext from '../../../state/SegmentationFiltersInstanceContext';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import styled from 'foundations-theming/utils';
import { DragHandleIcon, DeleteIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Box } from 'foundations-components/transitional/components/Box';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CONTAINER_WIDTH = 162;
const DraggableQuickFilterContainer = styled.div.withConfig({
  displayName: "DraggableQuickFilter__DraggableQuickFilterContainer",
  componentId: "tnjk09-0"
})(["", ""], props => props.draggable && `cursor: grab;

     &.dragging {
       opacity: 0;
     }
    `);
const DraggableQuickFilter = ({
  buttonProperties,
  draggable,
  propertyName,
  selectedOptionsCount,
  onDeleteQuickFilter,
  onFinishReordering
}) => {
  const {
    props: {
      baseFilterFamily
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    getFields
  } = useStrategy();
  const [showTooltip, setShowTooltip] = useState(true);
  const allFields = getFields(baseFilterFamily);
  const getLabel = () => {
    const field = allFields === null || allFields === void 0 ? void 0 : allFields.get(propertyName);
    const {
      label,
      type
    } = DSFieldRecord.isDSFieldRecord(field) ? field : {
      label: propertyName,
      type: undefined
    };
    if (type === ENUMERATION && selectedOptionsCount > 0 && !draggable) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.quickFiltersBar.enum.display",
        options: {
          propertyLabel: label,
          selectedOptionsCount
        }
      });
    }
    return label;
  };
  const onDragEnd = evt => {
    evt.preventDefault();
    const el = evt.target;
    if (el instanceof Element) {
      el.classList.remove('dragging');
      onFinishReordering(propertyName);
      setShowTooltip(true);
    }
  };
  const onDragStart = evt => {
    evt.stopPropagation();
    evt.dataTransfer.effectAllowed = 'move';
    const el = evt.target;
    if (el instanceof Element) {
      setTimeout(() => el.classList.add('dragging'), 0);
    }
  };
  const isActive = selectedOptionsCount > 0;
  return (
    /*#__PURE__*/
    // Trellis note: I reviewed and simplified the use of classNames as much as possible. I was not able to get this to work with attributes in place of classNames.
    // @bend-expect trellis-tokenized: className
    _jsx(DraggableQuickFilterContainer, {
      className: "draggable-quick-filter",
      draggable: draggable,
      id: propertyName,
      onDragEnd: onDragEnd,
      onDragStart: onDragStart,
      onMouseDown: () => setShowTooltip(false),
      onMouseUp: () => setShowTooltip(true),
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        backgroundColor: isActive ? BUTTON_ACTIVE_BACKGROUND_COLOR_TRELLIS : undefined,
        blockSize: `${buttonProperties.BUTTON_HEIGHT}px`,
        borderColor: "border-core-subtle",
        borderRadius: "200",
        borderStyle: "solid",
        borderWidth: "100",
        inlineSize: `${CONTAINER_WIDTH}px`,
        justifyContent: "space-between",
        children: [draggable && /*#__PURE__*/_jsx(Box, {
          children: /*#__PURE__*/_jsx(IconHolder, {
            icon: DragHandleIcon,
            "data-selenium-test": `EditPopover-dragHandle`,
            "data-selenium-info": propertyName,
            size: buttonProperties.DRAG_HANDLE_SIZE
          })
        }), /*#__PURE__*/_jsx(Box, {
          paddingInlineStart: draggable ? '0' : '200',
          grow: 1,
          children: /*#__PURE__*/_jsx(Text, {
            typography: "body-100",
            children: /*#__PURE__*/_jsx(TruncateString, {
              tooltip: showTooltip,
              children: getLabel()
            })
          })
        }), /*#__PURE__*/_jsx(Box, {
          children: /*#__PURE__*/_jsx(IconButton, {
            "data-selenium-test": `EditPopover-${propertyName}-delete`,
            onClick: onDeleteQuickFilter,
            size: buttonProperties.BUTTON_SIZE === 'sm' ? 'xs' : 'sm',
            use: "transparent",
            children: /*#__PURE__*/_jsx(IconHolder, {
              color: "icon-interactive-default",
              paddingInline: "100",
              icon: DeleteIcon
            })
          })
        })]
      })
    })
  );
};
export default DraggableQuickFilter;